import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from "react-router-dom";
import Landing from "./pages/Landing";
import Bece from "./pages/forms/Bece";
import Junior from "./pages/forms/Junior";
import Model from "./pages/forms/Model";
import Public from "./pages/forms/Public";
import ApplySchoolCode from "./pages/forms/ApplySchoolCode";
import Tedac from "./pages/forms/Tedac";
import LatePaymentForm from "./pages/forms/LatePaymentForm";
import ModelLatePaymentForm from "./pages/forms/ModelLatePayment";
import PublicSecLatePaymentForm from "./pages/forms/PublicSecLatePayment";
import LatePaymentFormJss from "./pages/forms/LatePaymentFormJss";
import ExamLoginBece from "./pages/forms/ExamLoginBece";
import ExamLoginCas from "./pages/forms/ExamLoginCas";
import PaymentRegisterBece from "./pages/forms/PaymentRegisterBece";
import PaymentLoginBece from "./pages/forms/PaymentLoginBece";
import PaymentRegisterCas from "./pages/forms/PaymentRegisterCas";
import PaymentLoginCas from "./pages/forms/PaymentLoginCas";
import PaymentRegisterModel from "./pages/forms/PaymentRegisterModel";
import PaymentLoginModel from "./pages/forms/PaymentLoginModel";
import PaymentRegisterPublic from "./pages/forms/PaymentRegisterPublic";
import PaymentRegisterTradeTest from "./pages/forms/PaymentRegisterTradeTest";
import PaymentLoginPublic from "./pages/forms/PaymentLoginPublic";
import PaymentRegisterTedac from "./pages/forms/PaymentRegisterTedac";
import PaymentLoginTedac from "./pages/forms/PaymentLoginTedac";
import ExamBoardModal from "./paymentcomp";
import Invoice from "./Component/invoice/Invoice";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import PaymentLoginTradeTest from "./pages/forms/PaymentLoginTradeTest";
import TradeTest from "./pages/forms/TradeTest";
import Invoicedownload from "./Component/invoice/Invoicedownload";
import { Construction } from "./Component/Construction";
import ResetPassword from "./Component/reset-password/ResetPassword";
import ResetPasswordRequest from "./Component/reset-password/ForgotPassword";
import NotFound from "./pages/NotFound";

const App = () => {
  return (

    <div className="app-parent-Container">
      {/* <Toaster> */}

      <ExamBoardModal />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />



      <Routes>

        <Route exact path="/" element={<Landing />} />
        <Route
          path="/requisition/apply-schoolId"
          element={<ApplySchoolCode />}
        />
              <Route path='/passwordReset/:token/:code' index={true} element={<ResetPassword />} />
              <Route path='/forgotPassword' index={true} element={<ResetPasswordRequest />} />
        <Route path="/requisition/bece" element={<Bece />} />
        <Route path="/requisition/junior" element={<Junior />} />
        <Route path="/requisition/model" element={<Model />} />
        <Route path="/requisition/model/maintenance" element={<Construction />} />
        <Route path="/requisition/public" element={<Public />} />
        <Route path="/requisition/tedac" element={<Tedac />} />
        <Route path="/requisition/tradetest" element={<TradeTest />} />
        {/* register */}
        <Route
          path="/bece/payment/register"
          element={<PaymentRegisterBece serviceType={"bece"} />}
        />
        <Route
          path="/cas/payment/register"
          element={<PaymentRegisterCas serviceType={"cas"} />}
        />
        <Route
          path="/model/payment/register"
          element={<PaymentRegisterModel />}
        />
        <Route
          path="/public/payment/register"
          element={<PaymentRegisterPublic />}
        />
        <Route
          path="/tedac/payment/register"
          element={<PaymentRegisterTedac />}
        />
        <Route
          path="/trade/test/payment/register"
          element={<PaymentRegisterTradeTest />}
        />

        <Route path="bece/exam/login" element={<ExamLoginBece />} />
        <Route path="cas/exam/login" element={<ExamLoginCas />} />
        {/* login */}
        <Route path="tradetest/payment/login" element={<PaymentLoginTradeTest />} />
        <Route path="bece/payment/login" element={<PaymentLoginBece />} />
        <Route path="cas/payment/login" element={<PaymentLoginCas />} />
        <Route path="model/payment/login" element={<PaymentLoginModel />} />
        <Route path="public/payment/login" element={<PaymentLoginPublic />} />
        <Route path="tedac/payment/login" element={<PaymentLoginTedac />} />

        <Route path="/requisition/bece-late-fee" element={<LatePaymentForm />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/invoice/download/:id" element={<Invoicedownload />} />
        <Route
          path="/requisition/cas-late-fee"
          element={<LatePaymentFormJss />}
        />
        <Route
          path="/requisition/model-late-fee"
          element={<ModelLatePaymentForm />}
        />
        <Route
          path="/requisition/public-late-fee"
          element={<PublicSecLatePaymentForm />}
        />

        {/* Catch-all: render 404 for any unknown route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;
